import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removespaces',
  standalone: false  //NOSONAR
})
export class RemoveSpacesPipe implements PipeTransform {
  transform(value: string, args?: any): string {
    return value.replace(/ /g, '');
  }
}
